module.exports = __webpack_public_path__ + "img/ryzs18.6335f602.jpg";